export const MENU_LOAD_DATA = 'MENU_LOAD_DATA';

export const ASYNC_MENU_LOAD_DATA = 'ASYNC_MENU_LOAD_DATA';
